import { render, staticRenderFns } from "./HistorySocialComponent.vue?vue&type=template&id=2adc8b0a&"
import script from "./HistorySocialComponent.vue?vue&type=script&lang=js&"
export * from "./HistorySocialComponent.vue?vue&type=script&lang=js&"
import style0 from "./HistorySocialComponent.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./HistorySocialComponent.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./HistorySocialComponent.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports